import { Formik } from 'formik';
import { useState, useEffect } from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GenericButton from '../../common/button/GenericButton/GenericButton';
import { Link } from 'react-router-dom';
import * as yup from 'yup';
import DatePicker from '../../../components/common/DatePicker';

const DoctorForm = ({
  formData,
  handleInput,
  validateProviderFacility,
  PhysicianValues,
}) => {
  const schema = yup.object({
    physicianslastname: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.PhysiciansLastName?.Mandatory === true,
        then: () => yup.string().required("Enter Physician's Last Name"),
        otherwise: () => yup.string().notRequired(),
      }),
    physiciansfirstname: yup.string().when('required', {
      is: () => PhysicianValues?.PhysiciansFirstName?.Mandatory === true,
      then: () => yup.string().required("Enter Physician's First Name"),
      otherwise: () => yup.string().notRequired(),
    }),
    physiciansfirstname: yup.string().when('required', {
      is: () => PhysicianValues?.PhysiciansFirstName?.Mandatory === true,
      then: () => yup.string().required("Please enter Physician's First Name"),
      otherwise: () => yup.string().notRequired(),
    }),
    speciality: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.Speciality?.Mandatory == true,
        then: () => yup.string().required(' Enter Speciality'),
        otherwise: () => yup.string().notRequired(),
      }),
    previousclaimnumber: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.Previousclaimnumber?.Mandatory == true,
        then: () => yup.string().required(' Enter Previous claimnumber'),
        otherwise: () => yup.string().notRequired(),
      }),
    physicianssocialsecuritynumber: yup
      .string()
      .ensure()
      .when('required', {
        is: () =>
          PhysicianValues?.PhysiciansSocialSecurityNumber?.Mandatory == true,
        then: () =>
          yup.string().required("Enter Physician's Social Security Number"),
        otherwise: () => yup.string().notRequired(),
      }),

    email: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.Email?.Mandatory == true,
        then: () =>
          yup
            .string()
            .required('Enter a valid email')
            .email('Enter Valid Email Address'),
        otherwise: () => yup.string().notRequired(),
      }),
    facilityaddressline1: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.FacilityAddressLine1?.Mandatory == true,
        then: () =>
          yup.string().required('Enter a valid Facility Address Line 1'),
        otherwise: () => yup.string().notRequired(),
      }),
    facilityaddressline3: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.FacilityAddressLine3?.Mandatory == true,
        then: () =>
          yup.string().required('Enter a valid Facility Address Line 3'),
        otherwise: () => yup.string().notRequired(),
      }),
    facilitycity: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.FacilityCity?.Mandatory == true,
        then: () => yup.string().required('Enter a valid Facility Cityname'),
        otherwise: () => yup.string().notRequired(),
      }),
    facilitystate: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.FacilityState?.Mandatory == true,
        then: () => yup.string().required('Enter a valid Facility State name'),
        otherwise: () => yup.string().notRequired(),
      }),
    physiciancertificatenumber: yup
      .string()
      .ensure()
      .when('required', {
        is: () =>
          PhysicianValues?.PhysicianCertificateNumber?.Mandatory == true,
        then: () => yup.string().required('Enter Physician Certificate Number'),
        otherwise: () => yup.string().notRequired(),
      }),
    phone: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.Phone?.Mandatory == true,
        then: () => yup.string().required('Enter a valid phone number'),
        otherwise: () => yup.string().notRequired(),
      }),
    physicianalternateid1: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.PhysicianAlternateID1?.Mandatory == true,
        then: () =>
          yup.string().required('Enter a valid Physician Alternate ID1'),
        otherwise: () => yup.string().notRequired(),
      }),
    physicianalternateid2: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.PhysicianAlternateID2?.Mandatory == true,
        then: () =>
          yup.string().required('Enter a valid Physician Alternate ID2'),
        otherwise: () => yup.string().notRequired(),
      }),
    licensestate: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.LicenseState?.Mandatory == true,
        then: () => yup.string().required('Enter a valid License State'),
        otherwise: () => yup.string().notRequired(),
      }),
    licensenumber: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.LicenseNumber?.Mandatory == true,
        then: () => yup.string().required(`Enter a valid License Number`),
        otherwise: () => yup.string().notRequired(),
      }),
    facilitytaxid: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.FacilityTaxId?.Mandatory == true,
        then: () => yup.string().required(`Enter a valid Facility TaxId`),
        otherwise: () => yup.string().notRequired(),
      }),
    facilitypostalcode: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.FacilityPostalCode?.Mandatory == true,
        then: () => yup.string().required('Enter a valid Facility PostalCode'),
        otherwise: () => yup.string().notRequired(),
      }),
    facilityname: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.FacilityName?.Mandatory == true,
        then: () => yup.string().required('Enter a valid Facility Name'),
        otherwise: () => yup.string().notRequired(),
      }),
    facilitynpi: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.FacilityNPI?.Mandatory == true,
        then: () => yup.string().required('Enter a valid Facility NPI'),
        otherwise: () => yup.string().notRequired(),
      }),
    facilitylicensestate: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.FacilityLicenseState?.Mandatory == true,
        then: () =>
          yup.string().required('Enter a valid Facility License State'),
        otherwise: () => yup.string().notRequired(),
      }),
    facilitylicensenumber: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.FacilityLicenseNumber?.Mandatory == true,
        then: () =>
          yup.string().required('Enter a valid Facility License Number'),
        otherwise: () => yup.string().notRequired(),
      }),
    facilitycertificatenumber: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.FacilityCertificateNumber?.Mandatory == true,
        then: () =>
          yup.string().required('Enter a valid Facility Certificate Number'),
        otherwise: () => yup.string().notRequired(),
      }),
    facilityalternateid2: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.FacilityAlternateID2?.Mandatory == true,
        then: () =>
          yup.string().required('Enter a valid Facility Alternate ID2'),
        otherwise: () => yup.string().notRequired(),
      }),
    facilityalternateid1: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.FacilityAlternateID1?.Mandatory == true,
        then: () =>
          yup.string().required('Enter a valid Facility Alternate ID1'),
        otherwise: () => yup.string().notRequired(),
      }),
    billingtaxid: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.BillingTaxID?.Mandatory == true,
        then: () => yup.string().required('Enter a valid Billing TaxID'),
        otherwise: () => yup.string().notRequired(),
      }),
    physiciansdateofbirth: yup
      .string()
      .ensure()
      .when('required', {
        is: () => PhysicianValues?.PhysiciansDateofBirth?.Mandatory == true,
        then: () =>
          yup
            .string()
            .max(new Date(), 'Date of birth must be in the past')
            .required("Enter a valid Billing Physician's Date of Birth"),
        otherwise: () => yup.string().notRequired(),
      }),
  });
  const [displayDate, setDisplayDate] = useState(null);
  const [dobValue, setDobValue] = useState(false);
  const formatPhone = (e) => {
    const target = e.target;
    const input = e.target.value.replace(/\D/g, '').substring(0, 10);

    //Based upon the length of the string, we add formatting as necessary
    if (input.length == 0) {
      target.value = input;
    } else if (input.length < 4) {
      target.value = '(' + input;
    } else if (input.length < 7) {
      target.value = '(' + input.substring(0, 3) + ') ' + input.substring(3, 6);
    } else {
      target.value =
        '(' +
        input.substring(0, 3) +
        ') ' +
        input.substring(3, 6) +
        ' ' +
        input.substring(6, 10);
    }
  };
  return (
    <>
      <div className="provider-user-profile-info">
        <div className="mt-4">
          <Row className="ml-0">
            <Col md={12} className="p-0">
              <Formik
                validationSchema={schema}
                initialValues={{
                  speciality: formData.speciality,
                  previousclaimnumber: formData.previousclaimnumber,
                  physicianslastname: formData.physicianslastname,
                  physiciansfirstname: formData.physiciansfirstname,
                  email: formData.email,
                  facilityaddressline1: formData.facilityaddressline1,
                  facilityaddressline3: formData.facilityaddressline3,
                  facilitycity: formData.facilitycity,
                  facilitystate: formData.facilitystate,
                  physiciancertificatenumber:
                    formData.physiciancertificatenumber,
                  phone: formData.phone,
                  physicianalternateid1: formData.physicianalternateid1,
                  physicianalternateid2: formData.physicianalternateid2,
                  licensestate: formData.licensestate,
                  licensenumber: formData.licensenumber,
                  facilitytaxid: formData.facilitytaxid,
                  facilitypostalcode: formData.facilitypostalcode,
                  facilityname: formData.facilityname,
                  facilitynpi: formData.facilitynpi,
                  facilitylicensestate: formData.facilitylicensestate,
                  facilitylicensenumber: formData.facilitylicensenumber,
                  facilitycertificatenumber: formData.facilitycertificatenumber,
                  facilityalternateid2: formData.facilityalternateid2,
                  facilityalternateid1: formData.facilityalternateid1,
                  billingtaxid: formData.billingtaxid,
                  physiciansdateofbirth: formData.physiciansdateofbirth,
                  physicianssocialsecuritynumber:
                    formData.physicianssocialsecuritynumber,
                }}
                onSubmit={() => {
                  validateProviderFacility();
                }}
              >
                {({
                  values,
                  touched,
                  errors,
                  status,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  setStatus,
                  setFieldValue,
                }) => {
                  return (
                    <Form onSubmit={handleSubmit}>
                      {PhysicianValues?.PhysiciansFirstName?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {
                                  PhysicianValues.PhysiciansFirstName
                                    .Description
                                }
                                {PhysicianValues.PhysiciansFirstName
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="physiciansfirstname"
                                placeholder=""
                                className={
                                  status && status.physiciansfirstname
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values?.physiciansfirstname}
                                isInvalid={
                                  touched.physiciansfirstname &&
                                  errors.physiciansfirstname
                                }
                                onChange={(e) => {
                                  console.log('firstname', e.target.value, e);
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.physiciansfirstname ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.physiciansfirstname}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.physiciansfirstname && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.physiciansfirstname &&
                                        errors.physiciansfirstname}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.PhysiciansLastName?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {PhysicianValues.PhysiciansLastName.Description}
                                {PhysicianValues.PhysiciansLastName
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="physicianslastname"
                                placeholder=""
                                className={
                                  status && status.physicianslastname
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values?.physicianslastname}
                                isInvalid={
                                  touched.physicianslastname &&
                                  errors.physicianslastname
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.physicianslastname ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.physicianslastname}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.physicianslastname && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.physicianslastname &&
                                        errors.physicianslastname}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.Speciality?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {PhysicianValues.Speciality.Fields}
                                {PhysicianValues.Speciality.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="speciality"
                                placeholder=""
                                className={
                                  status && status.speciality
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.speciality}
                                isInvalid={
                                  touched.speciality && errors.speciality
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.speciality ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.speciality}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.speciality && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.speciality && errors.speciality}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.Previousclaimnumber?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {PhysicianValues.Previousclaimnumber.Fields}
                                {PhysicianValues.Previousclaimnumber
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="previousclaimnumber"
                                placeholder=""
                                className={
                                  status && status.previousclaimnumber
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.previousclaimnumber}
                                isInvalid={
                                  touched.previousclaimnumber &&
                                  errors.previousclaimnumber
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.previousclaimnumber ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.previousclaimnumber}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.previousclaimnumber && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.previousclaimnumber &&
                                        errors.previousclaimnumber}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.Email?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {PhysicianValues.Email.Fields}
                                {PhysicianValues.Email.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="email"
                                placeholder=""
                                className={
                                  status && status.email ? 'is-invalid' : ''
                                }
                                value={values.email}
                                isInvalid={touched.email && errors.email}
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.email ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.email}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.email && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>{touched.email && errors.email}</span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.FacilityAddressLine1?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {PhysicianValues.FacilityAddressLine1.Fields}
                                {PhysicianValues.FacilityAddressLine1
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="facilityaddressline1"
                                placeholder=""
                                className={
                                  status && status.facilityaddressline1
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.facilityaddressline1}
                                isInvalid={
                                  touched.facilityaddressline1 &&
                                  errors.facilityaddressline1
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.facilityaddressline1 ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.facilityaddressline1}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.facilityaddressline1 && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.facilityaddressline1 &&
                                        errors.facilityaddressline1}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.FacilityAddressLine3?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {PhysicianValues.FacilityAddressLine3.Fields}
                                {PhysicianValues.FacilityAddressLine3
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="facilityaddressline3"
                                placeholder=""
                                className={
                                  status && status.facilityaddressline3
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.facilityaddressline3}
                                isInvalid={
                                  touched.facilityaddressline3 &&
                                  errors.facilityaddressline3
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.facilityaddressline3 ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.facilityaddressline3}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.facilityaddressline3 && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.facilityaddressline3 &&
                                        errors.facilityaddressline3}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.FacilityCity?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {PhysicianValues.FacilityCity.Fields}
                                {PhysicianValues.FacilityCity.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="facilitycity"
                                placeholder=""
                                className={
                                  status && status.facilitycity
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.facilitycity}
                                isInvalid={
                                  touched.facilitycity && errors.facilitycity
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.facilitycity ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.facilitycity}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.facilitycity && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.facilitycity &&
                                        errors.facilitycity}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.FacilityState?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {PhysicianValues.FacilityState.Fields}
                                {PhysicianValues.FacilityState.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="facilitystate"
                                placeholder=""
                                className={
                                  status && status.facilitystate
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.facilitystate}
                                isInvalid={
                                  touched.facilitystate && errors.facilitystate
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.facilitystate ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.facilitystate}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.facilitystate && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.facilitystate &&
                                        errors.facilitystate}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.PhysicianCertificateNumber?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {
                                  PhysicianValues.PhysicianCertificateNumber
                                    .Description
                                }
                                {PhysicianValues.PhysicianCertificateNumber
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="physiciancertificatenumber"
                                placeholder=""
                                className={
                                  status && status.physiciancertificatenumber
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.physiciancertificatenumber}
                                isInvalid={
                                  touched.physiciancertificatenumber &&
                                  errors.physiciancertificatenumber
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.physiciancertificatenumber ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>
                                    {status.physiciancertificatenumber}
                                  </span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.physiciancertificatenumber && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.physiciancertificatenumber &&
                                        errors.physiciancertificatenumber}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.Phone?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {PhysicianValues.Phone.Fields}
                                {PhysicianValues.Phone.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="phone"
                                placeholder=""
                                className={
                                  status && status.phone ? 'is-invalid' : ''
                                }
                                value={values.phone}
                                maxLength={14}
                                onKeyUp={(e) => formatPhone(e)}
                                isInvalid={touched.phone && errors.phone}
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.phone ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.phone}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.phone && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>{touched.phone && errors.phone}</span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.PhysicianAlternateID1?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {
                                  PhysicianValues.PhysicianAlternateID1
                                    .Description
                                }
                                {PhysicianValues.PhysicianAlternateID1
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="physicianalternateid1"
                                placeholder=""
                                className={
                                  status && status.physicianalternateid1
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.physicianalternateid1}
                                isInvalid={
                                  touched.physicianalternateid1 &&
                                  errors.physicianalternateid1
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.physicianalternateid1 ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.physicianalternateid1}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.physicianalternateid1 && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.physicianalternateid1 &&
                                        errors.physicianalternateid1}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.PhysicianAlternateID2?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {
                                  PhysicianValues.PhysicianAlternateID2
                                    .Description
                                }
                                {PhysicianValues.PhysicianAlternateID2
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="physicianalternateid2"
                                placeholder=""
                                className={
                                  status && status.physicianalternateid2
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.physicianalternateid2}
                                isInvalid={
                                  touched.physicianalternateid2 &&
                                  errors.physicianalternateid2
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.physicianalternateid2 ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.physicianalternateid2}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.physicianalternateid2 && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.physicianalternateid2 &&
                                        errors.physicianalternateid2}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.LicenseState?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {PhysicianValues.LicenseState.Fields}
                                {PhysicianValues.LicenseState.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="licensestate"
                                placeholder=""
                                className={
                                  status && status.licensestate
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.licensestate}
                                isInvalid={
                                  touched.licensestate && errors.licensestate
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.licensestate ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.licensestate}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.licensestate && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.licensestate &&
                                        errors.licensestate}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.LicenseNumber?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {PhysicianValues.LicenseNumber.Fields}
                                {PhysicianValues.LicenseNumber.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="licensenumber"
                                placeholder=""
                                className={
                                  status && status.licensenumber
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.licensenumber}
                                isInvalid={
                                  touched.licensenumber && errors.licensenumber
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.licensenumber ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.licensenumber}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.licensenumber && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.licensenumber &&
                                        errors.licensenumber}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.FacilityTaxId?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {PhysicianValues.FacilityTaxId.Fields}
                                {PhysicianValues.FacilityTaxId.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="facilitytaxid"
                                placeholder=""
                                className={
                                  status && status.facilitytaxid
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.facilitytaxid}
                                isInvalid={
                                  touched.facilitytaxid && errors.facilitytaxid
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.facilitytaxid ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.facilitytaxid}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.facilitytaxid && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.facilitytaxid &&
                                        errors.facilitytaxid}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.FacilityPostalCode?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {PhysicianValues.FacilityPostalCode.Fields}
                                {PhysicianValues.FacilityPostalCode
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="facilitypostalcode"
                                placeholder=""
                                className={
                                  status && status.facilitypostalcode
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.facilitypostalcode}
                                isInvalid={
                                  touched.facilitypostalcode &&
                                  errors.facilitypostalcode
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.facilitypostalcode ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.facilitypostalcode}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.facilitypostalcode && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.facilitypostalcode &&
                                        errors.facilitypostalcode}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.FacilityName?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {PhysicianValues.FacilityName.Fields}
                                {PhysicianValues.FacilityName.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="facilityname"
                                placeholder=""
                                className={
                                  status && status.facilityname
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.facilityname}
                                isInvalid={
                                  touched.facilityname && errors.facilityname
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.facilityname ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.facilityname}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.facilityname && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.facilityname &&
                                        errors.facilityname}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.FacilityNPI?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {PhysicianValues.FacilityNPI.Fields}
                                {PhysicianValues.FacilityNPI.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="facilitynpi"
                                placeholder=""
                                className={
                                  status && status.facilitynpi
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.facilitynpi}
                                isInvalid={
                                  touched.facilitynpi && errors.facilitynpi
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.facilitynpi ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.facilitynpi}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.facilitynpi && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.facilitynpi &&
                                        errors.facilitynpi}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.FacilityLicenseState?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {PhysicianValues.FacilityLicenseState.Fields}
                                {PhysicianValues.FacilityLicenseState
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="facilitylicensestate"
                                placeholder=""
                                className={
                                  status && status.facilitylicensestate
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.facilitylicensestate}
                                isInvalid={
                                  touched.facilitylicensestate &&
                                  errors.facilitylicensestate
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.facilitylicensestate ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.facilitylicensestate}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.facilitylicensestate && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.facilitylicensestate &&
                                        errors.facilitylicensestate}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.FacilityLicenseNumber?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {PhysicianValues.FacilityLicenseNumber.Fields}
                                {PhysicianValues.FacilityLicenseNumber
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="facilitylicensenumber"
                                placeholder=""
                                className={
                                  status && status.facilitylicensenumber
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.facilitylicensenumber}
                                isInvalid={
                                  touched.facilitylicensenumber &&
                                  errors.facilitylicensenumber
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.facilitylicensenumber ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.facilitylicensenumber}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.facilitylicensenumber && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.facilitylicensenumber &&
                                        errors.facilitylicensenumber}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.FacilityCertificateNumber?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {
                                  PhysicianValues.FacilityCertificateNumber
                                    .Fields
                                }
                                {PhysicianValues.FacilityCertificateNumber
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="facilitycertificatenumber"
                                placeholder=""
                                className={
                                  status && status.facilitycertificatenumber
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.facilitycertificatenumber}
                                isInvalid={
                                  touched.facilitycertificatenumber &&
                                  errors.facilitycertificatenumber
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.facilitycertificatenumber ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>
                                    {status.facilitycertificatenumber}
                                  </span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.facilitycertificatenumber && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.facilitycertificatenumber &&
                                        errors.facilitycertificatenumber}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.FacilityAlternateID2?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {PhysicianValues.FacilityAlternateID2.Fields}
                                {PhysicianValues.FacilityAlternateID2
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="facilityalternateid2"
                                placeholder=""
                                className={
                                  status && status.facilityalternateid2
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.facilityalternateid2}
                                isInvalid={
                                  touched.facilityalternateid2 &&
                                  errors.facilityalternateid2
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.facilityalternateid2 ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.facilityalternateid2}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.facilityalternateid2 && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.facilityalternateid2 &&
                                        errors.facilityalternateid2}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.FacilityAlternateID1?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {PhysicianValues.FacilityAlternateID1.Fields}
                                {PhysicianValues.FacilityAlternateID1
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="facilityalternateid1"
                                placeholder=""
                                className={
                                  status && status.facilityalternateid1
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.facilityalternateid1}
                                isInvalid={
                                  touched.facilityalternateid1 &&
                                  errors.facilityalternateid1
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.facilityalternateid1 ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.facilityalternateid1}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.facilityalternateid1 && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.facilityalternateid1 &&
                                        errors.facilityalternateid1}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.BillingTaxID?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {PhysicianValues.BillingTaxID.Fields}
                                {PhysicianValues.BillingTaxID.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="billingtaxid"
                                placeholder=""
                                className={
                                  status && status.billingtaxid
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.billingtaxid}
                                isInvalid={
                                  touched.billingtaxid && errors.billingtaxid
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.billingtaxid ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.billingtaxid}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.billingtaxid && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.billingtaxid &&
                                        errors.billingtaxid}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.PhysiciansDateofBirth?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {
                                  PhysicianValues.PhysiciansDateofBirth
                                    .Description
                                }
                                {PhysicianValues.PhysiciansDateofBirth
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <DatePicker
                                name="physiciansdateofbirth"
                                showIcon={true}
                                isDOB={true}
                                value={
                                  values.physiciansdateofbirth
                                    ? displayDate
                                    : null
                                }
                                onChange={(date) => {
                                  if (date) {
                                    setFieldValue(
                                      'physiciansdateofbirth',
                                      date,
                                    );
                                    setDisplayDate(date);
                                    setDobValue(false);
                                  } else {
                                    setFieldValue('physiciansdateofbirth', '');
                                    setDobValue(true);
                                  }
                                  handleInput(
                                    date,
                                    setFieldValue,
                                    handleChange,
                                    'physiciansdateofbirth',
                                  );
                                }}
                                //onBlur={(date) => {
                                //handleInput(
                                //date,
                                //setFieldValue(
                                //'physiciansdateofbirth',
                                //moment(date).format('YYYY-MM-DD'),
                                //),
                                //handleChange,
                                //'physiciansdateofbirth',
                                //);
                                //}}
                              />

                              {status && status.physiciansdateofbirth ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.physiciansdateofbirth}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.physiciansdateofbirth && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.physiciansdateofbirth &&
                                        errors.physiciansdateofbirth}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {PhysicianValues?.PhysiciansSocialSecurityNumber
                        ?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {
                                  PhysicianValues.PhysiciansSocialSecurityNumber
                                    .Description
                                }
                                {PhysicianValues.PhysiciansSocialSecurityNumber
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="physicianssocialsecuritynumber"
                                placeholder=""
                                className={
                                  status &&
                                  status.physicianssocialsecuritynumber
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values.physicianssocialsecuritynumber}
                                isInvalid={
                                  touched.physicianssocialsecuritynumber &&
                                  errors.physicianssocialsecuritynumber
                                }
                                onChange={(e) => {
                                  handleInput(e, setFieldValue, handleChange);
                                }}
                                onBlur={(e) => {
                                  handleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status &&
                              status.physicianssocialsecuritynumber ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>
                                    {status.physicianssocialsecuritynumber}
                                  </span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.physicianssocialsecuritynumber && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.physicianssocialsecuritynumber &&
                                        errors.physicianssocialsecuritynumber}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}

                      <Row className="mt-3 d-flex">
                        <Col sm={3} className="already-registered ">
                          Already registered?
                          <Link to="/admin">Login here. </Link>
                        </Col>
                        <Col sm={3} className="text-right">
                          {' '}
                          <GenericButton className="ml-1" type="submit">
                            NEXT
                          </GenericButton>
                        </Col>
                      </Row>
                    </Form>
                  );
                }}
              </Formik>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default DoctorForm;
